<template>
  <span v-html="formatter?formatter(scope.row[name]):scope.row[name]">
    <slot :scope="scope" :name="name">
      {{formatter?formatter(scope.row[name]):scope.row[name]}}
    </slot>
  </span>
</template>

<script>
export default {
  props:{
    formatter:Function,
    scope:Object,
    name:String
  },
  computed:{
    Formatter:()=>{
      console.log(this.scope)
      console.log("fmt", this.scope.row[this.name])
      return this.formatter?this.formatter(this.scope.row[this.name]):this.scope.row[this.name];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reportTable/slotItem.vue